/*
  © 2025 lumintheme
  https://www.lumintheme.com
*/

// Format money
window.Shopify.formatMoney = function (
  cents,
  moneyFormat = window.lumintheme.moneyFormat
) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function defaultOption(opt, def) {
    return typeof opt === "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    const cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (moneyFormat.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return moneyFormat.replace(placeholderRegex, value);
};

// Resize images
window.Shopify.resizeImage = function (src, size, crop = "") {
  return src
    .replace(
      /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
      "."
    )
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
      if (crop.length) {
        crop = `_crop_${crop}`;
      }
      return `_${size}${crop}${match}`;
    });
};

// Calculate "xx time ago"
window.Shopify.calcTimeAgo = function (timestamp) {
  const now = new Date().getTime();
  const diff = now - timestamp;

  // Get localized time text from window.lumintheme.times
  const times = window.lumintheme?.times;
  
  if (!times) {
    return 'time ago';
  }

  let text;

  if (diff < 60000) {
    text = times.moments;
  } else if (diff < 3.6e6) {
    const min = Math.round(diff / 60000);
    text = min === 1 ? `${min} ${times.minute}` : `${min} ${times.minutes}`;
  } else if (diff < 8.64e7) {
    const hours = Math.round(diff / 3.6e6);
    text = hours === 1 ? `${hours} ${times.hour}` : `${hours} ${times.hours}`;
  } else {
    const days = Math.round(diff / 8.64e7);
    text = days === 1 ? `${days} ${times.day}` : `${days} ${times.days}`;
  }

  // Check if the text already contains the "ago" equivalent to avoid duplication
  // For languages like Spanish (hace), French (il y a), Italian (fa), Portuguese (atrás), and German (vor), the text already includes the time indicator
  const currentLocale = window.lumintheme?.locale || 'en';
  
  if (currentLocale === 'es' || currentLocale === 'fr' || currentLocale === 'it' || currentLocale === 'pt-BR' || currentLocale === 'de') {
    // These languages already include the time indicator in their text
    return text;
  } else {
    // For other languages, append the "ago" text
    return `${text} ${times.ago}`;
  }
};

// Create cookie helper fuction
window.ksCreateCookie = function (name, value, days) {
  let date, expires;
  if (days) {
    date = new Date();
    date.setDate(date.getDate() + days);
    expires = "; expires=" + date.toUTCString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
};

// Lazy load autoplayed videos
const lazyVideosObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.play();
        entry.target.muted = true;
      }
    });
  },
  { rootMargin: "0px 0px 300px 0px" }
);
document.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
  lazyVideosObserver.observe(el);
});

// Fix - Megamenu is not closed when clicking within the fancy slideshow
document.querySelectorAll(".lumin-fancy-slideshow").forEach((elem) => {
  elem.addEventListener("click", () => {
    document.querySelectorAll(".mega-menu").forEach((elem) => {
      elem.removeAttribute("open");
    });
    document.querySelectorAll(".header__menu-item").forEach((elem) => {
      elem.setAttribute("aria-expanded", "false");
    });
  });
});

// HTML5 accordions add animation support
document.querySelectorAll(".accordion__content").forEach((element) => {
  const detailsElement = element.closest("details");
  const summaryElement = element.previousElementSibling;

  detailsElement.classList.add("accordion__details");

  const wrapper = document.createElement("div");
  element.parentNode.insertBefore(wrapper, element);
  wrapper.appendChild(element);
  wrapper.id = element.id;
  wrapper.classList = element.classList;

  element.removeAttribute("id");
  element.removeAttribute("class");

  if (wrapper.classList.contains("rte")) {
    wrapper.classList.remove("rte");
    element.classList.add("rte");
  }

  summaryElement.addEventListener("click", (event) => {
    if (wrapper.classList.contains("summary-animation")) {
      wrapper.classList.remove("summary-animation", "summary-collapsing");
      void element.offsetWidth;
      return;
    }

    const onAnimationEnd = (cb) =>
      wrapper.addEventListener("animationend", cb, { once: true });

    requestAnimationFrame(() => wrapper.classList.add("summary-animation"));
    onAnimationEnd(() => wrapper.classList.remove("summary-animation"));

    const isDetailsOpen = detailsElement.getAttribute("open") !== null;
    if (isDetailsOpen) {
      event.preventDefault();
      wrapper.classList.add("summary-collapsing");
      onAnimationEnd(() => {
        detailsElement.removeAttribute("open");
        wrapper.classList.remove("summary-collapsing");
      });
    }
  });
});

class LuminWishlistDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector(".drawer__overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.addEventListener("click", (event) => {
      if (event.target === this) {
        this.close();
      }
    });
    this.setIconsAccessibility();
  }

  setIconsAccessibility() {
    document
      .querySelectorAll('a[href="#lumin-wishlist-drawer"]')
      .forEach((link) => {
        link.addEventListener("click", (event) => {
          event.preventDefault();
          this.open(link);
        });
        link.addEventListener("keydown", (event) => {
          if (event.code.toUpperCase() === "SPACE") {
            event.preventDefault();
            this.open(link);
          }
        });
      });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
      document.body.classList.add("overflow-hidden");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : this.querySelector(".lumin-wishlist-drawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        window.trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove("active");
    window.removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("lumin-wishlist-drawer", LuminWishlistDrawer);

class LuminWishlistContainer extends HTMLElement {
  constructor() {
    super();

    // Initialize immediately
    this.setCountBadges();
    this.setContent();

    // Listen for changes in localStorage
    window.addEventListener('storage', (event) => {
      if (event.key === 'lumin-wishlist') {
        this.setCountBadges();
        this.setContent();
      }
    });
  }

  get wishlist() {
    try {
      const stored = localStorage.getItem("lumin-wishlist");
      const wishlist = stored ? JSON.parse(stored) : [];
      return Array.isArray(wishlist) ? wishlist : [];
    } catch (error) {
      return [];
    }
  }

  set wishlist(array) {
    try {
      if (!Array.isArray(array)) {
        return;
      }
      localStorage.setItem("lumin-wishlist", JSON.stringify(array));
      // Trigger storage event for other tabs/windows
      window.dispatchEvent(new StorageEvent('storage', {
        key: 'lumin-wishlist',
        newValue: JSON.stringify(array)
      }));
    } catch (error) {
    }
  }

  async setProduct(url) {
    let wishlist = this.wishlist;
    const isWishlisted = wishlist.some((elem) => elem.url === url);

    if (isWishlisted) {
      wishlist = wishlist.filter((elem) => elem.url !== url);
    } else {
      try {
        const response = await fetch(`${url}.js`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const product = await response.json();

        wishlist.push({
          url,
          id: product.id,
          handle: product.handle,
          title: product.title,
          img_src: product.featured_image,
          img_alt: product.featured_image.alt,
          compare_at_price: product.compare_at_price,
          price: product.price,
          price_varies: product.price_varies,
          added_at: Date.now(),
        });
      } catch (error) {
        return;
      }
    }

    this.wishlist = wishlist;
    this.setCountBadges();
    this.setContent();
  }

  setCountBadges() {
    const count = this.wishlist.length;
    document.querySelectorAll(".wishlist-count-bubble").forEach((elem) => {
      const countSpan = elem.querySelector("span");
      if (countSpan) {
        countSpan.textContent = count;
      }
      if (count > 0) {
        elem.removeAttribute("hidden");
      } else {
        elem.setAttribute("hidden", "hidden");
      }
    });
  }

  setContent() {
    const wishlist = this.wishlist;
    
    const emptyState = this.querySelector(".drawer__inner-empty.lumin-wishlist-empty");
    const productList = this.querySelector(".lumin-wishlist-drawer-product-list");
    const listWrapper = this.querySelector(".lumin-wishlist-drawer-product-list-wrapper");
    
    if (!emptyState || !productList || !listWrapper) {
      return;
    }

    if (wishlist && wishlist.length > 0) {
      emptyState.classList.add("hidden");
      this.classList.remove("is-empty");

      let productListHTML = "";
      let imgWidth = 600;
      let imgHeight = 600;

      switch (this.dataset.imgRatio) {
        case "ratio-4x3":
          imgWidth = 600;
          imgHeight = Math.round((600 / 4) * 3);
          break;
        case "ratio-3x4":
          imgWidth = Math.round((600 / 4) * 3);
          imgHeight = 600;
          break;
      }

      // "Add all to cart" header (rendered above items)
      productListHTML += `
        <div class="lumin-wishlist-header-cta">
          <button class="lumin-wishlist-add-all-btn button button--full-width button--primary" type="button">
            <span class="lumin-wishlist-add-all-btn-label">Adicionar tudo ao carrinho</span>
            <span class="lumin-wishlist-add-all-btn-loading" hidden>Adicionando...</span>
          </button>
        </div>
      `;

      wishlist.forEach((product, idx) => {
        const handle = product.handle || product.url.split('/products/')[1]?.split('?')[0]?.split('/')[0] || '';
        productListHTML += `
          <div class="lumin-wishlist-drawer-product-list-item lumin-grid-product-list-item" role="listitem" data-handle="${handle}" data-index="${idx}">
            <a href="${product.url}" tabindex="-1">
              <img
                src="${window.Shopify.resizeImage(
                  product.img_src,
                  `${imgWidth}x${imgHeight}`,
                  "center"
                )}"
                class="product-card-img img-fluid ${this.dataset.imgBorder}"
                alt="${product.img_alt}"
                width="${imgWidth}"
                height="${imgHeight}"
                loading="lazy">
            </a>
            <div class="lumin-wishlist-item-info">
              <h4 class="title h5 text-truncate">
                <a href="${product.url}" class="full-unstyled-link">
                  ${product.title}
                </a>
              </h4>
              <div class="lumin-wishlist-price-wrap">
                ${this.renderPrice(product.price, product.compare_at_price)}
              </div>
              <div class="lumin-wishlist-variant-wrap" hidden>
                <select class="lumin-wishlist-variant-select" aria-label="Escolha a variante">
                  <option>Carregando variantes...</option>
                </select>
              </div>
            </div>
            <div class="lumin-wishlist-item-actions">
              <button
                class="lumin-wishlist-product-item-btn-add"
                type="button"
                aria-label="Adicionar ao carrinho"
                data-product-handle="${handle}"
                data-product-url="${product.url}"
                disabled>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"></path>
                </svg>
              </button>
              <button
                class="lumin-wishlist-product-item-btn-remove"
                type="button"
                aria-label="Remove"
                data-product-url="${product.url}">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16" width="16" height="16">
                  <path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"></path><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"></path>
                </svg>
              </button>
            </div>
          </div>
        `;
      });

      productList.innerHTML = productListHTML;
      listWrapper.removeAttribute("hidden");

      // Async-load variants for every item, populate selects, enable add buttons
      this.hydrateVariants(wishlist);

      // Remove from wishlist — remove DOM node directly to avoid the "Carregando…" flicker.
      // We bypass the `wishlist` setter on purpose because that setter dispatches a
      // synthetic 'storage' event which the constructor listens for and would trigger a
      // full setContent() rerender — re-creating the variant select in its loading state.
      this.querySelectorAll(".lumin-wishlist-product-item-btn-remove").forEach((removeBtn) => {
        removeBtn.addEventListener("click", () => {
          const url = removeBtn.dataset.productUrl;
          const itemEl = removeBtn.closest('.lumin-wishlist-drawer-product-list-item');

          // Update localStorage directly (no setter → no storage event → no full rerender)
          const newList = this.wishlist.filter((item) => item.url !== url);
          try {
            localStorage.setItem('lumin-wishlist', JSON.stringify(newList));
          } catch (e) {}

          this.setCountBadges();
          if (itemEl) {
            const handle = itemEl.dataset.handle;
            if (this._productsCache && handle) delete this._productsCache[handle];
            itemEl.remove();
          }

          // Sync hearts on product cards
          document.querySelectorAll(".lumin-wishlist-btn").forEach((wishlistButton) => {
            if (typeof wishlistButton.adjustBtn === 'function') wishlistButton.adjustBtn();
          });

          // If list is now empty, switch to the empty state
          if (newList.length === 0) this.setContent();
        });
      });

      // Add single item to cart
      this.querySelectorAll(".lumin-wishlist-product-item-btn-add").forEach((addBtn) => {
        addBtn.addEventListener("click", async () => {
          if (addBtn.disabled) return;
          addBtn.disabled = true;
          try {
            await this.addItemToCart(addBtn.dataset.productHandle, addBtn.dataset.productUrl);
          } finally {
            addBtn.disabled = false;
          }
        });
      });

      // Add all to cart
      const addAllBtn = this.querySelector(".lumin-wishlist-add-all-btn");
      if (addAllBtn) {
        addAllBtn.addEventListener("click", async () => {
          if (addAllBtn.disabled) return;
          addAllBtn.disabled = true;
          addAllBtn.querySelector(".lumin-wishlist-add-all-btn-label").setAttribute("hidden", "");
          addAllBtn.querySelector(".lumin-wishlist-add-all-btn-loading").removeAttribute("hidden");
          try {
            await this.addAllToCart();
          } finally {
            addAllBtn.disabled = false;
            addAllBtn.querySelector(".lumin-wishlist-add-all-btn-label").removeAttribute("hidden");
            addAllBtn.querySelector(".lumin-wishlist-add-all-btn-loading").setAttribute("hidden", "");
          }
        });
      }
    } else {
      emptyState.classList.remove("hidden");
      this.classList.add("is-empty");
      productList.innerHTML = "";
      listWrapper.setAttribute("hidden", "hidden");
    }
  }

  // Fetch /products/{handle}.js and return the product JSON
  async fetchProduct(handle) {
    const res = await fetch(`${window.Shopify.routes.root || '/'}products/${handle}.js`);
    if (!res.ok) throw new Error(`Product fetch failed: ${res.status}`);
    return res.json();
  }

  // Build the inline HTML for a price (sale + optional strikethrough compare-at)
  renderPrice(price, compareAtPrice) {
    const fmt = window.Shopify.formatMoney;
    const onSale = compareAtPrice && compareAtPrice > price;
    if (onSale) {
      return `
        <div class="price price--on-sale">
          <div class="price__container">
            <div class="price__sale lumin-wishlist-price-row">
              <span class="price-item price-item--sale">${fmt(price)}</span>
              <s class="price-item price-item--regular">${fmt(compareAtPrice)}</s>
            </div>
          </div>
        </div>
      `;
    }
    return `
      <div class="price">
        <div class="price__container">
          <span class="price-item price-item--last">${fmt(price)}</span>
        </div>
      </div>
    `;
  }

  // POST items to /cart/add.js and refresh cart drawer if present
  async postToCart(items) {
    const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    let sections = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sections = cartDrawer.getSectionsToRender().map((s) => s.id);
    }
    const res = await fetch(`${window.Shopify.routes.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(data);
      if (cartDrawer.classList && cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }
    }
    return data;
  }

  // Fetch each wishlist product in parallel and populate the variant selects
  async hydrateVariants(wishlist) {
    const items = this.querySelectorAll('.lumin-wishlist-drawer-product-list-item');
    this._productsCache = {};
    await Promise.all(
      wishlist.map(async (item, idx) => {
        const itemEl = items[idx];
        if (!itemEl) return;
        const handle = itemEl.dataset.handle;
        const addBtn = itemEl.querySelector('.lumin-wishlist-product-item-btn-add');
        const variantWrap = itemEl.querySelector('.lumin-wishlist-variant-wrap');
        const select = itemEl.querySelector('.lumin-wishlist-variant-select');
        if (!handle || !addBtn || !select) return;

        try {
          const product = await this.fetchProduct(handle);
          this._productsCache[handle] = product;
          const variants = product.variants || [];
          const availableVariants = variants.filter((v) => v.available);

          if (variants.length === 0) {
            addBtn.title = 'Produto indisponível';
            return;
          }

          if (variants.length === 1) {
            // Single (or default) variant — no select needed
            variantWrap.setAttribute('hidden', '');
            itemEl.dataset.variantId = variants[0].id;
            if (variants[0].available) {
              addBtn.disabled = false;
            } else {
              addBtn.title = 'Esgotado';
            }
          } else {
            // Multiple variants — populate select
            select.innerHTML = variants
              .map(
                (v) =>
                  `<option value="${v.id}" ${!v.available ? 'disabled' : ''}>${v.title}${
                    !v.available ? ' — Esgotado' : ''
                  }</option>`
              )
              .join('');
            const first = availableVariants[0];
            if (first) {
              select.value = first.id;
              // Sync image + price to the variant that's selected by default —
              // otherwise we'd show the stored product.featured_image (the default
              // variant), which may not match the variant the select now shows.
              this.updateItemForVariant(itemEl, first, product);
            }
            variantWrap.removeAttribute('hidden');
            if (availableVariants.length > 0) {
              addBtn.disabled = false;
            } else {
              addBtn.title = 'Esgotado';
            }

            // Re-sync image + price when the user picks a different variant
            select.addEventListener('change', () => {
              const selectedId = Number(select.value);
              const variant = variants.find((v) => v.id === selectedId);
              if (variant) this.updateItemForVariant(itemEl, variant, product);
            });
          }
        } catch (e) {
          console.error('Wishlist hydrate failed for', handle, e);
          select.innerHTML = '<option>Erro ao carregar</option>';
        }
      })
    );
  }

  // Update an item's image + price to match the given variant
  updateItemForVariant(itemEl, variant, product) {
    if (!itemEl || !variant) return;

    // Image
    const img = itemEl.querySelector('img.product-card-img');
    if (img) {
      const variantImgSrc =
        variant.featured_image && variant.featured_image.src
          ? variant.featured_image.src
          : product.featured_image;
      if (variantImgSrc) {
        const w = img.getAttribute('width') || 600;
        const h = img.getAttribute('height') || 600;
        img.src = window.Shopify.resizeImage(variantImgSrc, `${w}x${h}`, 'center');
        if (variant.featured_image && variant.featured_image.alt) {
          img.alt = variant.featured_image.alt;
        }
      }
    }

    // Price (use the variant's own price + compare_at)
    const priceWrap = itemEl.querySelector('.lumin-wishlist-price-wrap');
    if (priceWrap) {
      priceWrap.innerHTML = this.renderPrice(variant.price, variant.compare_at_price);
    }
  }

  // Remove given URLs from the wishlist in a single update (no per-item re-render)
  clearFromWishlist(urls) {
    if (!Array.isArray(urls) || urls.length === 0) return;
    const remove = new Set(urls);
    this.wishlist = this.wishlist.filter((item) => !remove.has(item.url));
    this.setCountBadges();
    this.setContent();
    document.querySelectorAll('.lumin-wishlist-btn').forEach((btn) => {
      if (typeof btn.adjustBtn === 'function') btn.adjustBtn();
    });
  }

  // Resolve the variant ID that should be added for a given wishlist item element
  getSelectedVariantId(itemEl) {
    if (!itemEl) return null;
    if (itemEl.dataset.variantId) return Number(itemEl.dataset.variantId);
    const select = itemEl.querySelector('.lumin-wishlist-variant-select');
    if (select && select.value) return Number(select.value);
    return null;
  }

  // Add a single wishlist item using its selected variant
  async addItemToCart(handle, url) {
    const itemEl = this.querySelector(
      `.lumin-wishlist-drawer-product-list-item[data-handle="${handle}"]`
    );
    const variantId = this.getSelectedVariantId(itemEl);
    if (!variantId) {
      alert('Selecione uma variante disponível.');
      return;
    }
    try {
      await this.postToCart([{ id: variantId, quantity: 1 }]);
      // Remove the just-added item from the wishlist
      this.clearFromWishlist([url]);
      const wishlistDrawer = this.closest('lumin-wishlist-drawer');
      if (wishlistDrawer && typeof wishlistDrawer.close === 'function') wishlistDrawer.close();
    } catch (e) {
      console.error('Wishlist add error:', e);
    }
  }

  // Bulk add every item using each one's selected variant
  async addAllToCart() {
    const items = this.querySelectorAll('.lumin-wishlist-drawer-product-list-item');
    const itemsToAdd = [];
    const addedUrls = [];
    items.forEach((itemEl) => {
      const variantId = this.getSelectedVariantId(itemEl);
      if (variantId) {
        itemsToAdd.push({ id: variantId, quantity: 1 });
        const titleLink = itemEl.querySelector('.title a');
        if (titleLink && titleLink.getAttribute('href')) {
          addedUrls.push(titleLink.getAttribute('href'));
        }
      }
    });
    if (itemsToAdd.length === 0) {
      alert('Nenhuma variante disponível para adicionar.');
      return;
    }
    try {
      await this.postToCart(itemsToAdd);
      // Remove all just-added items from the wishlist
      this.clearFromWishlist(addedUrls);
      const wishlistDrawer = this.closest('lumin-wishlist-drawer');
      if (wishlistDrawer && typeof wishlistDrawer.close === 'function') wishlistDrawer.close();
    } catch (e) {
      console.error('Wishlist bulk-add failed', e);
    }
  }
}

customElements.define("lumin-wishlist-container", LuminWishlistContainer);

class LuminWishlistBtn extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('button');
    if (!this.btn) return;

    // Lazy: find container at click time so DOM order doesn't matter
    this.adjustBtn();

    this.btn.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      // Always get fresh container reference at click time
      const container = document.querySelector('lumin-wishlist-container');
      if (!container) return;

      await container.setProduct(this.dataset.productUrl);
      this.adjustBtn();
    });
  }

  getContainer() {
    return document.querySelector('lumin-wishlist-container');
  }

  adjustBtn() {
    const container = this.getContainer();
    if (!container || !this.btn) return;

    const isWishlisted = container.wishlist.some(
      (elem) => elem.url === this.dataset.productUrl
    );

    const wishlistText = window.kondasoft?.wishlist || {
      add: 'Add to wishlist',
      remove: 'Remove from wishlist'
    };

    if (isWishlisted) {
      this.btn.classList.add('active');
      this.btn.setAttribute('aria-label', wishlistText.remove);
      this.btn.setAttribute('aria-pressed', 'true');
    } else {
      this.btn.classList.remove('active');
      this.btn.setAttribute('aria-label', wishlistText.add);
      this.btn.setAttribute('aria-pressed', 'false');
    }
  }
}
customElements.define("lumin-wishlist-btn", LuminWishlistBtn);

class LuminRecentlyViewedDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector(".drawer__overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.addEventListener("click", (event) => {
      if (event.target === this) {
        this.close();
      }
    });
    this.setIconsAccessibility();
  }

  setIconsAccessibility() {
    document
      .querySelectorAll('a[href="#lumin-recently-viewed-drawer"]')
      .forEach((link) => {
        link.addEventListener("click", (event) => {
          event.preventDefault();
          this.open(link);
        });
        link.addEventListener("keydown", (event) => {
          if (event.code.toUpperCase() === "SPACE") {
            event.preventDefault();
            this.open(link);
          }
        });
      });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : this.querySelector(".lumin-recently-viewed-drawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        window.trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    window.removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("lumin-recently-viewed-drawer", LuminRecentlyViewedDrawer);

class LuminRecentlyViewedContainer extends HTMLElement {
  constructor() {
    super();

    this.initTriggers();
    this.setContent();
    this.handleRemoveAll();
  }

  get recentlyViewed() {
    return JSON.parse(localStorage.getItem("lumin-recently-viewed")) || [];
  }

  set recentlyViewed(array) {
    localStorage.setItem("lumin-recently-viewed", JSON.stringify(array));
  }

  initTriggers() {
    document.querySelectorAll("[data-recently-viewed-set]").forEach((elem) => {
      this.setProduct(elem.dataset.productUrl).catch(error => {
      });
    });
  }

  async setProduct(url) {
    let recentlyViewed = this.recentlyViewed;
    const isViewed = this.recentlyViewed.some((elem) => elem.url === url);

    if (isViewed) {
      recentlyViewed = this.recentlyViewed.filter((elem) => elem.url !== url);
    }

    const response = await fetch(`${url}.js`);
    const product = await response.json();
    //
    function keepLastXItemsInArray(arr, x) {
      if (x >= 0 && x <= arr.length) {
        return arr.slice(-x);
      } else {
        return arr;
      }
    }

    recentlyViewed = keepLastXItemsInArray(
      recentlyViewed,
      Number(this.dataset.limit)
    );

    this.recentlyViewed = recentlyViewed;
    this.setContent();
  }

  setContent() {
    if (this.recentlyViewed.length) {
      this.querySelector(".drawer__inner-empty.lumin-recently-viewed-empty").classList.add("hidden");
      this.classList.remove("is-empty");

      let productList = "";
      let imgWidth, imgHeight;

      switch (this.dataset.imgRatio) {
        case "ratio-4x3":
          imgWidth = 600;
          imgHeight = Math.round((600 / 4) * 3);
          break;
        case "ratio-3x4":
          imgWidth = Math.round((600 / 4) * 3);
          imgHeight = 600;
          break;
        default:
          imgWidth = 600;
          imgHeight = 600;
      }

      this.recentlyViewed.forEach((product) => {
        productList += `
          <div class="lumin-recently-viewed-drawer-product-list-item lumin-grid-product-list-item" role="listitem">
            <a href="${product.url}" tabindex="-1">
              <img 
                src="${window.Shopify.resizeImage(
                  product.img_src,
                  `${imgWidth}x${imgHeight}`,
                  "center"
                )}"
                class="img-fluid ${this.dataset.imgBorder}" 
                alt="${product.img_alt}" 
                width="${imgWidth}" 
                height="${imgHeight}" 
                loading="lazy">
            </a>
            <div class="">
              <h4 class="title h5 text-truncate">
                <a href="${product.url}" class="full-unstyled-link">
                  ${product.title}
                </a>
              </h4>
              <div class="price">
                <div class="price__container">
                  <span class="price-item price-item--last">
                      ${window.Shopify.formatMoney(product.price)}
                  </span>
                </div>
              </div>
              <div class="lumin-grid-product-list-item-added-at">
                <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                ${window.Shopify.calcTimeAgo(product.added_at)}
              </div>
            </div>
            <button 
              class="lumin-recently-viewed-product-item-btn-remove"
              type="button"
              aria-label="Remove"
              data-product-url="${product.url}">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16" width="16" height="16"> 
                <path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"></path><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"></path>
              </svg>
            </button>
          </div>
        `;
      });

      this.querySelector(".lumin-recently-viewed-drawer-product-list").innerHTML =
        productList;
      this.querySelector(
        ".lumin-recently-viewed-drawer-product-list-wrapper"
      ).removeAttribute("hidden");

      this.querySelectorAll(
        ".lumin-recently-viewed-product-item-btn-remove"
      ).forEach((removeBtn) => {
        removeBtn.addEventListener("click", () => {
          let recentlyViewed = this.recentlyViewed.filter(
            (elem) => elem.url !== removeBtn.dataset.productUrl
          );
          this.recentlyViewed = recentlyViewed;
          this.setContent();
        });
      });
    } else {
      this.querySelector(".drawer__inner-empty.lumin-recently-viewed-empty").classList.remove("hidden");
      this.classList.add("is-empty");
      this.querySelector(".lumin-recently-viewed-drawer-product-list").innerHTML =
        "";
      this.querySelector(
        ".lumin-recently-viewed-drawer-product-list-wrapper"
      ).setAttribute("hidden", "hidden");
    }
  }

  handleRemoveAll() {
    document
      .querySelectorAll(".lumin-recently-viewed-btm-remove-all")
      .forEach((btn) => {
        btn.addEventListener("click", () => {
          this.recentlyViewed = [];
          this.setContent();
        });
      });
  }
}

customElements.define(
  "lumin-recently-viewed-container",
  LuminRecentlyViewedContainer
);
